import React, { FC } from 'react';

import './ScoreCell.scss';

export interface ScoreCellProps {
  getValue: () => number | null | undefined;
}

/**
 * ENK-554 Response score on the dashboard.
 * The API decides who can see it (reviewers always, proponents once the response is Final)
 * and sends null otherwise, which is rendered as a dash.
 */
const ScoreCell: FC<ScoreCellProps> = ({ getValue }) => {
  const value = getValue();

  return <span className="enkrateia-score-cell">{value ?? '–'}</span>;
};

export default ScoreCell;
